module.exports = __webpack_public_path__ + "media/images/auth/rectangles_l2-ddb5ae7389627cbb1a9338c1ebc29bc1.png";